import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { routes } from "../../constants/routes";
import {
  getBusinessProfileById,
  updateBusinessProfile,
  updateBusinessProfileImage,
  updateBusinessProfileCover,
  updateBusinessProfileDocument,
  updateBusinessProfileImages,
  BusinessProfileDeleteImage,
} from "../../services/BusinessProfileService";

import { getStateList } from "../../services/StateService";
import { getCountryList } from "../../services/CountryService";

import { BusinessProfileModel } from "../../components/Model/businessProfileModel";
import { CommonModal } from "../../shared/commonModal";
import Modal from "../../components/Modal/Modal";
import ImageUpload from "../../components/Image/ImageUpload";
import ImagePreview from "../../components/Image/ImagePreview";
import DocumentUpload from "../../components/Document/DocumentUpload";
import { AuthService } from "../../services";
import Avatar from "../../components/Image/AvatarPreview";
import { globalConstant } from "../../constants/globalConstant";
import ImageUploadMulti from "../../components/Image/ImageUploadMulti";
import { UserRoleType } from "../../constants/Enum";
import { injectModels } from "../../redux/injectModels";
import { handleConsoleError } from "../../utils/common-methods";

const BusinessProfile = (props) => {
  const [stateList, setStateList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  //const [documentsList, setDocumentsList] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [businessData, setBusinessData] = useState({ ...BusinessProfileModel });
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isMultiImageModalOpen, setMultiImageModalOpen] = useState(false);
  const [isDocumentModalOpen, setDocumentModalOpen] = useState(false);
  const [isCoverImage, setCoverImage] = useState(false);
  const [previewImageURL, setPreviewImageURL] = useState("");
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const openMultiImageModal = () => setMultiImageModalOpen(true);
  const closeMultiImageModal = () => setMultiImageModalOpen(false);
  const coverImage = () => setCoverImage(true);
  // const openDocumentModal = () => setDocumentModalOpen(true);
  const closeDocumentModal = () => setDocumentModalOpen(false);
  const loginUser = AuthService.getLoginUser();
  const [isCountrySelected, setIsCountrySelected] = useState(false);

  const [showModal1, setShowModal1] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const openCoverModal = () => {
    setPreviewImageURL(businessData?.coverPicWide);
    openModal();
    coverImage();
  };
  const onSubmit = async (data) => {
    console.log(data);
    try {
      if (!data?.countryId) {
        data.countryId = null;
      }
      data.userId = loginUser?.id;
      if (data?.countryId === "") {
        data.countryId = null;
      }
      if (data?.stateId === "") {
        data.stateId = null;
      }
      data.numberofemployees =
        data.numberofemployees === null ? 0 : data.numberofemployees;
      const response = await updateBusinessProfile(data);
      if (response?.isSuccess) {
        getBusinessProfile();
        setShowModal(false);
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const removeImage = async (imgId) => {
    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this image?"
      );
      if (!isConfirmed) {
        return;
      }
      const data = new FormData();
      data.append("Id", imgId);
      const response = await BusinessProfileDeleteImage(data);
      if (response?.isSuccess) {
        getBusinessProfile();
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const handleShowModal = () => {
    setShowModal(true);
    reset(businessData);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    reset(BusinessProfileModel);
  };
  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append("Image", file.get("image")); // Field name must match the property in C# model
    formData.append("Id", loginUser?.id); // Optional field
    try {
      const response = isCoverImage
        ? await updateBusinessProfileCover(formData)
        : await updateBusinessProfileImage(formData);
      if (response?.isSuccess) {
        setCoverImage(false);
        closeModal();
        getBusinessProfile();
        toast.success(response?.message);
      }
    } catch (err) {
       const message = handleConsoleError(err);
      toast.error(err?.message||message);
     
    }
  };
  const handleMultiImageUpload = async (file) => {
    const formData = new FormData();
    file.getAll("images").forEach((image) => {
      formData.append("Image", image); // Match the field name in C# model
    }); // Field name must match the property in C# model
    formData.append("UserId", loginUser?.id); // Optional field
    try {
      const response = await updateBusinessProfileImages(formData);
      if (response?.isSuccess) {
        closeMultiImageModal();
        getBusinessProfile();
        toast.success(response?.message);
      }     
    } catch (err) {
      const message = handleConsoleError(err);
       toast.error(err?.message||message);
    }
  };
  const handleDocumentUpload = async (file) => {
    const formData = new FormData();
    formData.append("Documents", file.get("Document")); // Field name must match the property in C# model
    formData.append("UserId", loginUser?.id); // Optional field
    formData.append("DocumentsType", file.get("DocumentType")); // Optional field
    formData.append("Title", file.get("Title"));
    formData.append("ExpiryDate", file.get("ExpiryDate"));
    try {
      const response = await updateBusinessProfileDocument(formData);
      if (response?.isSuccess) {
        closeDocumentModal();
        getBusinessProfile();
        toast.success(response?.message);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const setSelectedState = (value) => {
    if (value) {
      setSelectedStateId(value);
    } else {
      setSelectedStateId("");
    }
  };

  const getBusinessProfile = async () => {
    try {
      props.application.setLoading(true);
      const userId = loginUser?.id;
      const business = await getBusinessProfileById(userId);
      const stateList = await getStateList();
      const countryList = await getCountryList();

      if (business.isSuccess) {
        business.data.video = "";
        //  setDocumentsList(business.data.documents);
        setImageList(business?.data?.images);
        const businessMappedData = {
          ...BusinessProfileModel,
          ...business?.data,
        };
        reset(businessMappedData);
        setBusinessData(businessMappedData);

        setStateList(stateList?.data || []);
        setCountryList(countryList?.data || []);
      } else {
        reset(BusinessProfileModel);
        setStateList(stateList?.data || []);
        setCountryList(countryList?.data || []);
      }

      if (business.data.countryId) {
        setSelectedCountryId(business?.data?.countryId);
        setBusinessData((prev) => ({
          ...prev,
          country: countryList.data.find(
            (country) => country.id === business?.data?.countryId
          ),
        }));
      }
      if (business?.data?.stateId) {
        setSelectedStateId(business?.data?.stateId);
        setBusinessData((prev) => ({
          ...prev,
          state: stateList.data.find(
            (state) => state?.id === business?.data?.stateId
          ),
        }));
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getBusinessProfile();
  }, []);

  useEffect(() => {}, [selectedDocument]);

  const filteredStates = stateList.filter(
    (state) => state?.countryId === selectedCountryId
  );

  const setSelectedCountry = (value) => {
    if (value) {
      setSelectedCountryId(value);
    } else {
      setSelectedCountryId("");
      setSelectedStateId("");
    }
  };

  const openProfileModal = () => {
    setPreviewImageURL(
      businessData?.businessLogo && businessData?.businessLogoUrl
    );
    openModal();
  };

  // const handlePreview = (document) => {
  //   // Get file extension
  //   const fileExtension = document.docsUrl
  //     .split(".")
  //     .pop()
  //     .toLowerCase();

  //   // Check if file is a PDF
  //   if (fileExtension === "pdf") {
  //     window.open(document.docsUrl, "_blank"); // Open PDF in new tab
  //   } else {
  //     // Open modal for images
  //     setSelectedDocument(document);
  //     setShowModal1(true);
  //   }
  // };

  const handleClose = () => {
    setShowModal1(false);
    setSelectedDocument(null);
  };

  // const handleRemove = (documentId) => {
  //   removeDoc(documentId);
  // };

  return (
    <React.Fragment>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ImageUpload
          imageURL={previewImageURL}
          onUpload={handleImageUpload}
          maxSize={4 * 1024 * 1024}
          validTypes={["image/png", "image/gif", "image/jpeg"]}
        ></ImageUpload>
      </Modal>
      <Modal isOpen={isDocumentModalOpen} onClose={closeDocumentModal}>
        <DocumentUpload
          onUpload={handleDocumentUpload}
          maxSize={20 * 1024 * 1024}
          validTypes={[
            "image/png",
            "image/gif",
            "image/jpeg",
            "application/pdf",
          ]}
        ></DocumentUpload>
      </Modal>

      {/* {showModal1 && selectedDocument && (
        <Modal isOpen={showModal1} onClose={handleClose} size="lg" centered>
          <div className="pr-view1">
            <h5
              style={{
                color: "#ec2e7b",
                fontWeight: "700",
                fontSize: "35px",
                marginBottom: "15px",
              }}
            >
              Document Preview
            </h5>
            <DocumentPreview
              fileUrl={selectedDocument.docsUrl}
              fileName={selectedDocument.title}
            />
            </div>
        </Modal>
      )} */}

      {showModal1 && selectedDocument && (
        <Modal isOpen={showModal1} onClose={handleClose} size="lg">
          <div className="pr-view1">
            <h5
              style={{
                color: "#ec2e7b",
                fontWeight: "700",
                fontSize: "35px",
                marginBottom: "15px",
              }}
            >
              Document Preview
            </h5>
            {selectedDocument?.docsUrl.match(/\.(jpeg|jpg|png|gif)$/i) ? (
              <img
                src={selectedDocument?.docsUrl}
                alt="Preview"
                style={{ width: "100%", height: "auto", borderRadius: "8px" }}
              />
            ) : (
              <p>Unsupported file type</p>
            )}
          </div>
        </Modal>
      )}

      <section className="bread-head">
        <div className="container">
          <div className="row bread-head3">
            <div className="col-lg-12 col-sm-12">
              <div className="bread-head2">
                <h5>
                  <Link to={routes.ACCOUNT_DASHBOARD}>Account</Link>{" "}
                  <i className="fa-solid fa-chevron-right"></i> Business profile
                </h5>
              </div>
            </div>
            <Modal
              isOpen={isMultiImageModalOpen}
              onClose={closeMultiImageModal}
            >
              <ImageUploadMulti
                onUpload={handleMultiImageUpload}
                maxSize={4 * 1024 * 1024}
                validTypes={["image/png", "image/gif", "image/jpeg"]}
              ></ImageUploadMulti>
            </Modal>
          </div>
        </div>
      </section>

      <section className="edit-form">
        <div className="container">
          <div className="row edit22">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="edit-form2-img">
                <div className="edit-form2-img1">
                  <Avatar
                    imageUrl={
                      businessData?.businessLogo &&
                      businessData?.businessLogoUrl
                    }
                    altText={
                      businessData?.businessName
                        ? businessData?.businessName?.toUpperCase()[0] +
                          "" +
                          businessData?.businessName?.toUpperCase()[1]
                        : loginUser?.firstName?.toUpperCase()[0] +
                          "" +
                          loginUser?.lastName?.toUpperCase()[0]
                    }
                    size={80}
                    borderColor={globalConstant.COLOR_PINK}
                    backgroundColor={globalConstant.COLOR_LITE}
                  />
                </div>
                {/* </div> */}
                <div className="edit-form2-text2">
                  <h3>
                    {businessData?.businessName
                      ? businessData?.businessName
                      : loginUser?.firstName + "" + loginUser?.lastName}
                  </h3>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="edit-text3">
                <h3>
                  <span onClick={openProfileModal}>
                    <i className="fa-solid fa-pen-to-square"></i> edit logo
                  </span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="form-edit55">
        <div className="container edit33">
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-12">
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Business Name</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5> {businessData?.businessName}</h5>
                </div>
              </div>

              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Legal Business Name</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5> {businessData?.leagalBusinessName}</h5>
                </div>
              </div>

              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Contact Legal Name</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.contactlegalname}</h5>
                </div>
              </div>

              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Contact Preferred Name</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.contactpreferredname}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Description</h4>
                </div>
                {/* <div className="edit-label11 edit-last2">
                  <h5>{businessData?.description}</h5>
                </div> */}
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5
                    style={{
                      height: 150,
                    }}
                  >
                    {" "}
                    <p
                      style={{
                        width: "100%", // Make the textarea take up the full width of its container
                        height: "120px", // Set the height of the textarea
                        overflowY: "auto", // Enable vertical scrolling when content overflows
                        resize: "none", // Allow the user to resize the textarea
                      }}
                    >
                      {businessData?.description}
                    </p>
                  </h5>
                </div>
              </div>

              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Address</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>
                    {" "}
                    {businessData?.address || ""}
                    {businessData?.city ? `, ${businessData?.city},` : ""}
                    {businessData.state?.stateName
                      ? ` ${businessData?.state?.stateName},`
                      : ""}
                    {businessData?.zipCode ? ` ${businessData?.zipCode},` : ""}
                    {businessData?.country?.countryName
                      ? ` ${businessData?.country?.countryName}`
                      : ""}{" "}
                  </h5>
                </div>
              </div>

              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Email</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.email}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Phone</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.phone}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Vat Number</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.vatNumber}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Business Registration Number</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.businessRegistrationNumber}</h5>
                </div>
              </div>

              {/* <div className="edit-label">
                <div className="edit-label1 edit-last1">
                  <h4>Currency</h4>
                </div>
                <div className="edit-label11 edit-last2">
                  <h5>{businessData?.currency}</h5>
                </div>
              </div> */}

              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Website</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.website}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Number Of Employees</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{businessData?.numberofemployees}</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <div className="test-edit">
                <h6>
                  <span onClick={handleShowModal}>
                    <i className="fa-solid fa-pen-to-square"></i> edit
                  </span>
                </h6>
              </div>

              {loginUser?.role?.toString() ===
                UserRoleType.TRADERRETAILER.toString() ||
              loginUser?.role?.toString() ===
                UserRoleType.MOBILECATERERS.toString() ? (
                <div className="test-edit">
                  <Link
                    to={`${routes.TRADER_PROFILE.replace(
                      ":id",
                      businessData?.userId
                    ).replace(":appId", "trader-profile")}`}
                  >
                    {" "}
                    <h6>
                      <span>
                        <i className="fa-solid fa-star"></i> External View
                      </span>
                    </h6>
                  </Link>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="form-edit55 login">
        <div className="container edit33">
          <h2>Cover picture</h2>
          <div className="row">
            <div className="col-lg-6 col-sm-12">
              <div className="Pictures-add">
                <div className="Pictures-add1">
                  <h6>Wide view</h6>
                  {/* <img src="assets/images/picture.png" alt="" /> */}
                  <ImagePreview
                    src={businessData?.coverPicWide}
                    width="300px"
                    height="200px"
                    style={{
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      BorderAll: "dark",
                      boxshadow: "green",
                    }}
                  />
                </div>

                <div className="Pictures-add1">
                  <h6>Square view</h6>
                  {/* <img src="assets/images/picture.png" alt="" /> */}
                  <ImagePreview
                    src={businessData?.coverPicSmall}
                    width="200px"
                    height="200px"
                    style={{
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      BorderAll: "dark",
                      boxshadow: "green",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="test-edit">
                <h6>
                  <span onClick={openCoverModal}>
                    <i className="fa-solid fa-pen-to-square"></i> edit
                  </span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="form-edit55 login">
        <div className="container edit33">
          <h2>Documents</h2>
          <div className="row">
            <div className="col-lg-12 col-sm-12">
              <div className="test-edit">
                <h6>
                  <span onClick={openDocumentModal}>
                    <i className="fa-solid fa-plus"></i> add{" "}
                  </span>
                </h6>
              </div>
            </div>
            <div className="col-lg-12 col-sm-12">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Document Type</th>
                      <th>Title</th>
                      <th>Expiry Date</th>                    
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentsList.map((document, idx) => (
                      <tr key={idx}>
                        <td>{document.docsType}</td>
                        <td>{document.title ? document.title : "-"}</td>
                        <td>
                          {document.expiryDate ? document.expiryDate : "N/A"}
                        </td>
                      
                        <td>
                          <span
                            onClick={() => handlePreview(document)}
                            style={{
                              cursor: "pointer",
                              marginRight: "10px",
                              color: "#007bff",
                            }}
                          >
                            <i className="ri-eye-fill"></i> Preview
                          </span>
                          <span
                            onClick={() => handleRemove(document.documentId)}
                            style={{ cursor: "pointer", color: "#FD5D6B" }}
                          >
                            <i className="ri-close-fill"></i> Remove
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="form-edit55 login">
        <div className="container edit33">
          <div className="d-flex justify-content-between">
            <h2>Pictures</h2>
            <div className="test-edit">
              <h6>
                <span onClick={openMultiImageModal}>
                  <i className="fa-solid fa-plus"></i> add{" "}
                </span>
              </h6>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-sm-12">
              <div className="Pictures-add">
                <div className=" row justify-content-start d-flex flex-row">
                  {imageList.map((image, index) => (
                    <div
                      className=" Pictures-add1"
                      key={index}
                      style={{ width: "120px" }}
                    >
                      <ImagePreview
                        src={image?.imageUrls}
                        width="100px"
                        onDelete={removeImage}
                        imageId={image?.imageId}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CommonModal
        show={showModal}
        onHide={handleCloseModal}
        title={"Update Business Information"}
        footerActions={[
          { label: "Close", variant: "secondary", onClick: handleCloseModal },
          {
            label: "Update",
            type: "button",
            onClick: handleSubmit(onSubmit),
          },
        ]}
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
           <Form.Control            
                        type="hidden"
                        name="email"
                        value={businessData?.email}
                      />
          <Form.Group controlId="businessName">
            <Form.Label>
              Business Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              maxLength={100}
              type="text"
              {...register("businessName", {
                required: "Business name is required",
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "businessName",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={businessData?.businessName}
            />
            {errors?.businessName && (
              <span className="text-danger">{errors?.businessName?.message}</span>
            )}
          </Form.Group>

          <Form.Group controlId="leagalBusinessName">
            <Form.Label>Legal Business Name</Form.Label>
            <Form.Control
              maxLength={100}
              type="text"
              {...register("leagalBusinessName")}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "leagalBusinessName",
                  value.charAt(0).toUpperCase() + value.slice(1)
                );
              }}
              defaultValue={businessData?.leagalBusinessName}
            />
            {errors?.leagalBusinessName && (
              <span className="text-danger">
                {errors?.leagalBusinessName?.message}
              </span>
            )}
          </Form.Group>

          <Form.Group controlId="contactlegalname">
            <Form.Label>Contact Legal name</Form.Label>
            <Form.Control
              maxLength={100}
              type="text"
              {...register("contactlegalname")}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "contactlegalname",
                  value.charAt(0).toUpperCase() + value.slice(1)
                );
              }}
              defaultValue={businessData?.contactlegalname}
            />
            {errors?.contactlegalname && (
              <span className="text-danger">
                {errors?.contactlegalname?.message}
              </span>
            )}
          </Form.Group>
          <Form.Group controlId="contactpreferredname">
            <Form.Label>Contact Preferred Name</Form.Label>
            <Form.Control
              maxLength={100}
              type="text"
              {...register("contactpreferredname")}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "contactpreferredname",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={businessData?.contactpreferredname}
            />
            {errors?.contactpreferredname && (
              <span className="text-danger">
                {errors?.contactpreferredname?.message}
              </span>
            )}
          </Form.Group>
          <Form.Group controlId="country">
            <Form.Label>
              State <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              //as="select"
              {...register("countryId", {
                required: "State is required",
              })}
              value={selectedCountryId}
              onChange={(e) => {
                const countryId = e.target.value;
                setSelectedCountry(e.target.value);
                setIsCountrySelected(countryId !== "");
              }}
            >
              <option value="">Select State</option>
              {countryList.map((country) => (
                <option key={country?.id} value={country?.id}>
                  {country?.countryName}
                </option>
              ))}
            </Form.Select>
            {errors?.countryId && (
              <span className="text-danger">{errors?.countryId?.message}</span>
            )}
          </Form.Group>

          <Form.Group controlId="address">
            <Form.Label>
              Street Address{" "}
              {isCountrySelected && <span className="text-danger">*</span>}{" "}
            </Form.Label>
            <Form.Control
              maxLength={200}
              type="text"
              {...register("address", {
                required: isCountrySelected
                  ? "Street Address is required"
                  : false,
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "address",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
            />
            {errors?.address && (
              <span className="text-danger">{errors?.address?.message}</span>
            )}
          </Form.Group>

          <Form.Group controlId="city">
            <Form.Label>
              City {isCountrySelected && <span className="text-danger">*</span>}
            </Form.Label>
            <Form.Control
              maxLength={75}
              type="text"
              {...register("city", {
                required: isCountrySelected ? "City is required" : false,
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "city",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
            />
            {errors.city && (
              <span className="text-danger">{errors?.city?.message}</span>
            )}
          </Form.Group>

          <Form.Group controlId="state">
            <Form.Label>
              Country{" "}
              {isCountrySelected && <span className="text-danger">*</span>}
            </Form.Label>
            <Form.Select
              // as="select"
              {...register("stateId", {
                required: isCountrySelected ? "Country is required" : false,
              })}
              value={selectedStateId}
              onChange={(e) => {
                setSelectedStateId(e.target.value);
                setSelectedState(e.target.value);
              }}
            >
              <option value="">Select Country</option>
              {filteredStates.map((state) => (
                <option key={state?.id} value={state?.id}>
                  {state?.stateName}
                </option>
              ))}
            </Form.Select>
            {errors?.stateId && (
              <span className="text-danger">{errors?.stateId?.message}</span>
            )}
          </Form.Group>

          <Form.Group controlId="zipCode">
            <Form.Label>
              Zip/Postal Code{" "}
              {isCountrySelected && <span className="text-danger">*</span>}
            </Form.Label>
            <Form.Control
              maxLength={15}
              type="text"
              {...register("zipCode", {
                required: isCountrySelected
                  ? "Zip/Postal Code is required"
                  : false,
                pattern: {
                  value: /^[A-Za-z0-9\s-]{3,10}$/,
                  message: "Invalid Postal Code",
                },
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "zipCode",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={businessData?.zipCode}
            />
            {errors?.zipCode && (
              <span className="text-danger">{errors?.zipCode?.message}</span>
            )}
          </Form.Group>
          {/* <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              maxLength={100}
              type="email"
              {...register("email", {
                pattern: {
                  value: globalConstant.emailRegex,
                  message: "Invalid Email",
                },
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "email",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={businessData?.email}
            />
            {errors?.email && (
              <span className="text-danger">{errors?.email?.message}</span>
            )}
          </Form.Group> */}

          <Form.Group controlId="phone">
            <Form.Label>
              Phone Number <i className="text-danger"></i>
            </Form.Label>
            <Form.Control
              maxLength={15}
              type="text"
              {...register("phone", {
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]\d{8,14}$/,
                  message: "Invalid phone number",
                },
              })}
              defaultValue={businessData?.phone}
            />
            {errors.phone && (
              <span className="text-danger">{errors?.phone?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="vatNumber">
            <Form.Label>Vat Number</Form.Label>
            <Form.Control
              maxLength={12}
              minLength={8}
              type="text"
              {...register("vatNumber", {
                pattern: {
                  value: /^[a-zA-Z0-9]{8,12}$/,
                  message: `The vat number must be  alphanumeric and be 8 digits long`,
                },
              })}
              defaultValue={businessData?.vatNumber}
            />
            {errors.vatNumber && (
              <span className="text-danger">{errors?.vatNumber?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="businessRegistrationNumber">
            <Form.Label>
              Business Registration Number<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              maxLength={8}
              type="text"
              {...register("businessRegistrationNumber", {
                required: "registration number is required",
                pattern: {
                  value: /^[a-zA-Z0-9]{8}$/,
                  message:
                    "The registration number must be  alphanumeric and be 8 digits long",
                },
              })}
              defaultValue={businessData?.businessRegistrationNumber}
            />
            {errors?.businessRegistrationNumber && (
              <span className="text-danger">
                {errors?.businessRegistrationNumber?.message}
              </span>
            )}
          </Form.Group>

          <Form.Group controlId="website">
            <Form.Label>Website</Form.Label>
            <Form.Control
              maxLength={100}
              type="url"
              {...register("website", {
                pattern: {
                  value: /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/,
                  message: "Invalid URL",
                },
              })}
              defaultValue={businessData?.website}
            />
            {errors.website && (
              <span className="text-danger">{errors?.website?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="numberofemployees">
            <Form.Label>
              Number of Employees <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              maxLength={9}
              type="text"
              {...register("numberofemployees", {
                required: "Number of employees required",
                pattern: {
                  value: /^[1-9]\d{0,9}$/,
                  message: "Invalid Number",
                },
              })}
              defaultValue={
                businessData?.numberofemployees === null
                  ? 0
                  : businessData?.numberofemployees
              }
            />

            {errors?.numberofemployees && (
              <span className="text-danger">
                {errors?.numberofemployees?.message}
              </span>
            )}
          </Form.Group>

          <Form.Group controlId="description">
            <Form.Label>Description</Form.Label>
            <Form.Control as="textarea" rows={3} {...register("description")} />
            {errors?.description && (
              <span className="text-danger">{errors?.description?.message}</span>
            )}
          </Form.Group>
        </Form>
      </CommonModal>
    </React.Fragment>
  );
};
export default injectModels(["application"])(BusinessProfile);
